import React from 'react'
import {Box, useMultiStyleConfig} from '@chakra-ui/react'
import {DelonghiBigLogoIcon} from '../icons/shared'

const FooterBrandLogoSection = () => {
    const styles = useMultiStyleConfig('Footer', {variant: 'default'})

    return (
        <Box {...styles?.brandLogoSection?.container}>
            <DelonghiBigLogoIcon {...styles?.brandLogoSection?.logo} />
        </Box>
    )
}

export default FooterBrandLogoSection
